import { B2BFilterResponse } from '@/b2b/types';
import CutwiseAPIClient, { METHOD_GET } from '@/common/network/CutwiseAPIClient';
import QueryResult from '@/common/network/QueryResult';

export const PATH_FILTERS = 'api/v2/b2b/filters';

export default class B2BAPI {
  fetchB2BFilters(): Promise<QueryResult<B2BFilterResponse>> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_GET).path(PATH_FILTERS);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }
}
